if (!customElements.get('gift-redeem-button')) {
  customElements.define(
    'gift-redeem-button',
    class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.redeem.bind(this));
      }

      redeem() {
        this.textContent = 'Adding...';
        this.style.pointerEvents = 'none';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              {
                id: parseInt(this.dataset.variantId),
                quantity: 1,
                properties: { _is_free: 'true' },
              },
            ],
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname,
          }),
        })
          .then((r) => r.json())
          .then((data) => {
            if (data.status) return;
            const drawer = document.querySelector('cart-drawer');
            if (drawer) drawer.renderContents(data);
          });
      }
    }
  );
}

if (!customElements.get('gift-auto-remove')) {
  customElements.define(
    'gift-auto-remove',
    class extends HTMLElement {
      connectedCallback() {
        const line = parseInt(this.dataset.line);
        this.remove();

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            line: line,
            quantity: 0,
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname,
          }),
        })
          .then((r) => r.json())
          .then((data) => {
            if (data.status) return;
            const drawer = document.querySelector('cart-drawer');
            if (drawer) drawer.renderContents(data);
          });
      }
    }
  );
}
